export default {
    Ten: 10,
    Twenty: 20,
    Thirty: 30,
    Fifty: 50,
    Hundred: 100
}